import { BookState } from '../../types';
import { BookAction, bookActionTypes } from '../type';

const initialState: BookState = {
  loading: false,
  words: [],
  error: null,
  page: 0,
  group: 0,
};
export const bookReducer = (state = initialState, action: BookAction) => {
  switch (action.type) {
    case bookActionTypes.FETCH_WORDS:
      return {
        ...state,
        loading: true,
      };
    case bookActionTypes.FETCH_WORDS_SUCCESS:
      return {
        ...state,
        loading: false,
        words: action.payload,
      };
    case bookActionTypes.FETCH_WORDS_USER:
      return {
        ...state,
        loading: true,
      };
    case bookActionTypes.FETCH_WORDS_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        words: action.payload,
      };
    case bookActionTypes.SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };
    case bookActionTypes.SET_GROUP:
      return {
        ...state,
        group: action.payload,
      };
    default:
      return state;
  }
};
